import React from 'react';
import { ListFieldSection, PageSection, FieldSet, SectionGroup } from '../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown, IWithWorksheetInjectedProps } from '../../../Core';
import { Field, TextOutput, RadioGroup, Checkbox, Label } from '../../../../Core';
import PlasticLimitTrialSection from './PlasticLimitTrialSection';
import { useSelector } from 'react-redux';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let PlasticLimitPageSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );
  const llResultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false))
  );

  return (
    <PageSection heading="Plastic Limit">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Rolled By"
          name="PlasticLimit.RolledBy"
          options={[
            { label: 'Hand', value: 'Hand' },
            { label: 'Mechanical Rolling Device', value: 'Mechanical' },
          ]}
        />
      </ListFieldSection>
      <SectionGroup heading="Plastic Limit Determination">
        <NamePrefixModifier appendNamePrefix="PlasticLimit">
          <ListFieldSection>
            <FieldSet>
              <Label>Material Suitability</Label>
              <Field
                input={<Checkbox />}
                label="Result cannot be obtained"
                name="NonPlastic"
                disabled={llResultNotObtainable}
              />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet label="Balance" name="Balance" />
                <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
                <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
              </ListFieldSection>
              <PlasticLimitTrialSection />
            </>
          )}
        </NamePrefixModifier>
      </SectionGroup>
      <ListFieldSection heading="Result">
        {determinationPerformed ? (
          <Field input={<TextOutput />} label="Moisture Content (%)" name="Results.PlasticLimit" />
        ) : (
          <Field input={<TextOutput />} label="Moisture Content (%)" value="N/A" />
        )}
        <Field input={<TextOutput />} label="Plastic Limit" name="Results.PlasticLimitText" />
      </ListFieldSection>
    </PageSection>
  );
};

PlasticLimitPageSection = withInjectedProps(PlasticLimitPageSection);

export { PlasticLimitPageSection };
export default PlasticLimitPageSection;
